import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import PaymentMethods from "@/pages/PaymentMethods";
import Status from "@/pages/Status";
import AdminChat from "@/pages/AdminChat";
import ChatWidget from "@/components/ChatWidget";

function App() {
  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment-methods" element={<PaymentMethods />} />
            <Route path="/status" element={<Status />} />
            <Route path="/admin/chat" element={<AdminChat />} />
          </Routes>
          <ChatWidget />
        </BrowserRouter>
      </div>
    </CartProvider>
  );
}

export default App;
